import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=2c84d0e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c84d0e7"]])

export default __exports__